import { createAction } from 'redux-actions';

export const setLoadingCatalogoAction = createAction(
  'EMISION_ASEGURADOS__SET_LOADING_CATALOGO',
);
export const setCatalogoAction = createAction('EMISION__ASEGURADOS__SET_CATALOGO');

export const setShowFormAgregarAction = createAction(
  'EMISION__ASEGURADOS__SET_SHOW_FORM_AGREGAR',
);

export const resetStateAction = createAction('EMISION__ASEGURADOS__RESET_STATE');

export const setLoadingEditarBeneficiariosAction = createAction(
  'EMISION__ASEGURADOS__SET_LOADING_EDITAR_BENEFICIARIOS',
);
